<template>
  <div>
    <dl>
      <div class="border-b py-1 text-xs">
        <dt class="text-sm leading-5 font-medium text-gray-400 mb-1">
          {{ $t(`mygwf.components.Label.measuring_point`) }}
        </dt>
        <dd class="text-sm leading-5 font-medium text-black sm:mt-0 sm:col-span-2">
          {{
            details.customer_measuring_point_id || details.measuring_point_id || details.mpid || '-'
          }}
        </dd>
      </div>
      <div class="bg-white border-b py-1 text-xs">
        <dt class="text-sm leading-5 font-medium text-gray-500">
          {{ $t('mygwf.components.Grid.name') }}
        </dt>
        <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
          {{ details.mp_name || details.name || '-' }}
        </dd>
      </div>
      <div class="bg-white border-b py-1 text-xs">
        <dt class="text-sm leading-5 font-medium text-gray-500">
          {{ $t(`mygwf.components.Label.meter`) }}
        </dt>
        <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
          {{ details.meter_serial || details.meter_serial_number || '-' }}
        </dd>
      </div>
      <div v-if="details.comd_serial" class="border-b py-1 text-xs">
        <dt class="text-sm leading-5 font-medium text-gray-500">Module</dt>
        <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
          {{ details.comd_serial }} ({{ details.comd_type }})
        </dd>
      </div>
      <div v-if="details.state && details.state.volume" class="bg-white border-b py-1 text-xs">
        <dt class="text-sm leading-5 font-medium text-gray-500">
          {{ $t(`mygwf.components.Label.map_volume`) }}
        </dt>
        <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
          {{ details.state.volume }}
          <span class="text-xs text-gray-700">m<sup>3</sup></span>
        </dd>
      </div>
    </dl>
  </div>
</template>

<script>
export default {
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style></style>
